import { initBackButtons, initNextButtonAbusePrevention, initFormSubmit } from '../../helpers';
import { opts, additionalOptions } from '../../config';

export function removeEvents() {
	window.modForm = Object.assign(window.modForm, opts, additionalOptions);
	initFormSubmit(false);
	initBackButtons(false);
	initNextButtonAbusePrevention(false);
}
